// extracted by mini-css-extract-plugin
module.exports = {"row":"ToolsPage_row__1WKe6","card":"ToolsPage_card__2VrvF","disabled":"ToolsPage_disabled__2BbtX","image":"ToolsPage_image__1IVEs","text":"ToolsPage_text__2eK2B"};